import React, { useEffect, useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { queryParams } from "../../../helpers/UrlHelpers";
import { fetchPhoneNumberPrices } from "../../../actions/callrecorder/phoneNumberPricesActions";
import callrecorderUrls from "src/configs/callrecorder/callrecorderUrls";

import PageLayout from '../_partials/PageLayout';
import Edit from "./Edit";
import ListTable from "./_partials/_ListTable";
import PageHeader from "../../../componets/PageHeader";
import Wrapper from "../../../componets/Wrapper";
import Filter from "../../../componets/Filter";

const LIMIT = 42;
const DEFAULT_ORDER_BY = 'id';

const NAV_ITEMS: {[index: number]: any} = {
  1: { id: 1, name: 'No Address',       url: callrecorderUrls.phoneNumberPricesPath({ order_by: DEFAULT_ORDER_BY, address_required: 'false' }) },
  2: { id: 2, name: 'Address Required', url: callrecorderUrls.phoneNumberPricesPath({ order_by: DEFAULT_ORDER_BY, address_required: 'true' }) },
};

const PhoneNumberPrices = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams, 'page') || 1;
  const { pathname } = useLocation();

  const activeNavId = useMemo(() => {
    const addressRequired = searchParams.get('address_required');
    if (addressRequired === 'false') return 1;
    if (addressRequired === 'true') return 2;
    return undefined;
  }, [searchParams]);

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['term', 'search_by', 'order_by', 'order', 'country_code', 'phone_number_type', 'provider_id', 'sms_enabled', 'mms_enabled', 'trunking_enabled', 'address_required', 'beta', 'date_from', 'date_to']
    );

    dispatch(fetchPhoneNumberPrices(params));
  }, [searchParams, pathname, currentPage, dispatch]);

  return (
    <PageLayout className='v-phone-number-prices'>
      <PageHeader
        title='Number Prices'
        navs={NAV_ITEMS}
        activeId={activeNavId}
        parent={{
          name: 'All',
          url: callrecorderUrls.phoneNumberPricesPath({ order_by: DEFAULT_ORDER_BY })
        }}
      />

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter dateRange />
        </Wrapper>

        <ListTable limit={LIMIT} />
      </div>

      <Edit />
    </PageLayout>
  );
}

export default PhoneNumberPrices;
